<template>
    <div>
        <div v-if="complete && (panel.should_order || panel.should_not_order)" class="md-elevation-4" style="display: inline-block; padding: 10px; border-radius: 3px; margin-bottom: 25px; font-weight: bold;"
        :style="{'background-color': determinePanelBgColor(panel, panelPurchased)}">
            <div v-if="panel.should_order">
                <span v-if="panelPurchased">
                    This panel is necessary to make the proper diagnosis, good job.
                </span>
                <span v-else>
                    This panel was necessary for making the proper diagnosis.
                </span>
            </div>
            <div v-else-if="panel.should_not_order">
                <span v-if="panelPurchased">
                    This panel is of low value and should not be ordered in this case.
                </span>
                <span v-else>
                    This panel was of low value and should not to be ordered in this case.
                </span>
            </div>
        </div>
        <div v-if="!panelPurchased" class="lab-panel">
            <div>
                <b>Panel #{{panelIndex+1}}:</b>
                {{panel.name}}
                <div v-if="panel.cost" style="margin-top: 6px;"><span>Cost: ${{panel.cost}}</span></div>
            </div>
            <div class="lab-panel-btns">
                <md-tooltip md-direction="top" v-if="!complete">Purchase Test</md-tooltip>
                <md-button class="md-icon-button md-dense md-primary md-raised" 
                @click="$emit('purchasePanel', [panel.id, panel.should_order, panel.cost])"
                    :disabled="complete">
                    <md-icon>play_arrow</md-icon>
                </md-button>
                <br>
            </div>
        </div>
        <div v-if="panelPurchased">
            <h2 class="panel-name-header">
                Results for: {{panel.name}}
            </h2>
            <hr>
            <div v-if="panel.info.corpus">
                <div v-html="sanitize(panel.info.corpus)" class="highlightable" 
                style="text-align: center; padding: 8px; border: 1px #ccc solid; margin-bottom: 20px;"/>
                <hr>
            </div>
            <div v-if="panel.results && panel.results.filter((x) => x.name != '' || x.value != '').length > 0">
                <md-table class="lab-table highlightable" v-if="useVerticalLayout">
                    <md-table-row>
                        <md-table-head></md-table-head>
                        <md-table-head v-for="result in panel.results" :key="result.id">
                            {{result.name}}
                        </md-table-head>
                    </md-table-row>
                    <md-table-row>
                        <md-table-cell>Measured Value</md-table-cell>
                        <md-table-cell v-for="result in panel.results" :key="result.id">
                            {{result.value}}
                        </md-table-cell>
                    </md-table-row>
                    <md-table-row>
                        <md-table-cell>Reference Range</md-table-cell>
                        <md-table-cell v-for="result in panel.results" :key="result.id">
                            {{result.refRange}}
                        </md-table-cell>
                    </md-table-row>
                    <md-table-row>
                        <md-table-cell>Flag</md-table-cell>
                        <md-table-cell v-for="result in panel.results" :key="result.id">
                            <span style="display: none"> | </span>
                            <div class="flag-cell" :style="{'background-color': calcFlagColor(result)}">
                                <b>{{calcFlag(result)}}</b>
                            </div>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
                <md-table class="lab-table" v-if="!useVerticalLayout">
                    <md-table-row>
                        <md-table-head>Measurement</md-table-head>
                        <md-table-head>Measured Value</md-table-head>
                        <md-table-head>Reference Range</md-table-head>
                        <md-table-head>Flag</md-table-head>
                    </md-table-row>
                    <md-table-row v-for="result in panel.results" :key="result.id" class="highlightable">
                        <md-table-cell>{{result.name}} <span style="display: none">| </span></md-table-cell>
                        <md-table-cell>{{result.value}} <span style="display: none">| </span></md-table-cell>
                        <md-table-cell>{{result.refRange}}</md-table-cell>
                        <md-table-cell>
                            <span style="display: none"> | </span>
                            <div class="flag-cell" :style="{'background-color': calcFlagColor(result)}">
                                <b>{{calcFlag(result)}}</b>
                            </div>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </div>
            <ResourceGallery :resourceList="panel.info.resources"></ResourceGallery>
            <hr>
        </div>
    </div>
</template>

<script>
    import APIRequests from "../APIRequests.js"
    import ResourceGallery from './Gallery.vue' 
	const DOMPurify = require("dompurify")()

    export default {
        props: {
            panel: {
                type: Object
            },
            panelIndex: {
                type: Number
            },
            complete: {
                type: Boolean
            },
            panelPurchased: {
                type: Boolean
            },
            useVerticalLayout: {
                type: Boolean
            },
        },
        data: function () {
            return {
                presetData: {},
            }
        },
        components: {
            ResourceGallery,
        },
        methods: {
            sanitize: function(content){
				return DOMPurify.sanitize(content)
			},
            loadPresetData: function () {
                this.presetID = this.$route.query.presetID
                if (!this.presetID) return
                let api_url = this.$store.state.api_url + "/api/panelPresets/" + this.presetID
                APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
                    if (!data) data = {}
                    this.presetData = data
                })
            },
            calcFlagColor: function(result){
                let flagName = this.calcFlag(result)
                if(flagName ==  "CHECK"){
                    return "#f8fa63"
                } 
                if(flagName == ""){
                    return "inherit"
                }
                return "#fd8585"    
            },
            calcFlag: function(result){
                if(result.refRange == result.value){
                    return ""
                }
                if(isNaN(parseFloat(result.value))){
                    return "CHECK"
                }
                let refRangeRegex = /([+-]?\d*(?:.\d+)?)\s?[-\u2013\u2014]\s?([+-]?\d*(?:.\d+)?)/
                let regexResult = result.refRange.match(refRangeRegex)
                if(regexResult) {
                    let lowBoundary = parseFloat(regexResult[1])
                    let highBoundary = parseFloat(regexResult[2])
                    if(highBoundary < lowBoundary){
                        lowBoundary = highBoundary
                        highBoundary = parseFloat(regexResult[1])
                    }
                    let normalFlag = result.value <= highBoundary && result.value >= lowBoundary
                    if(!normalFlag){
                        if(result.value > highBoundary) {
                            return "HIGH"
                        }
                        if(result.value < lowBoundary) {
                            return "LOW"
                        }
                    }
                    else {
                        return ""
                    }
                }
                refRangeRegex = /<\s?([+-]?\d*(?:.\d+)?)/
                regexResult = result.refRange.match(refRangeRegex)
                if(regexResult) {
                    let highBoundary = parseFloat(regexResult[1])
                    if(result.value <= highBoundary) {
                        return ""
                    }
                    return "HIGH"
                }
                refRangeRegex = />\s?([+-]?\d*(?:.\d+)?)/
                regexResult = result.refRange.match(refRangeRegex)
                if(regexResult) {
                    let highBoundary = parseFloat(regexResult[1])
                    if(result.value >= highBoundary) {
                        return ""
                    }
                    return "LOW"
                }
                return "CHECK"
            },
            determinePanelBgColor: function(panel, purchased){
                if(!panel.should_order && !panel.should_not_order){
                    return "#f4f4f4"
                }
                return ((!purchased && panel.should_order) || (purchased && panel.should_not_order)) ? "#fd8585" : "#74e38d"
            },

        },
        mounted: function () {
            this.$nextTick(function () {
                this.loadPresetData()
            })
        }
    }
</script>

<style scoped>
    .md-dialog:not(.vertical-layout) {
        max-width: 96vw !important;
        width: 96vw;
        max-height: 100vh !important;
    }
    .lab-table {
        width: 100%;
        text-align: center; 
    }
    .md-card.md-table{
        margin-left: 0px;
    }
    .md-table >>> .md-table-head-container{
        display: flex
    }
    .md-table >>> .md-table-head-label{
        margin: auto;
    }
    .lab-panel{
        position: relative;
        min-height: 60px; 
        text-align: left; 
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        font-size: 110%;
        padding: 10px 60px 10px 10px;
    }
    .lab-panel-btns{
        position: absolute;
        right: 10px;
    }
    .flag-cell{
        border-radius: 5px;
         display: inline-block;
         padding: 5px 8px;
         font-size: 85%;
    }
    .panel-name-header{
        text-transform: uppercase;
    }
    .vertical-layout .panel-name-header{
        word-break: break-word;
    }
</style>